module.exports = __webpack_public_path__ + "img/cs-home-3.3437e8cc.jpg";